/** Visit keys are draft identities only. Persisted identity remains ordered legs. */
export interface RouteVisit { key: string; locationID: string }
let nextVisit = 0;
export const createVisit = (locationID: string): RouteVisit => ({key: `visit-${++nextVisit}`, locationID});
export const visitsFromIDs = (ids: string[]) => ids.map(createVisit);

export function orderedLocations<T extends {_id: string}>(ids: string[], locations: T[]): T[] {
    const byID = new Map(locations.map(location => [location._id, location]));
    const missing = ids.filter(id => !byID.has(id));
    if (missing.length) throw new Error(`Location data is unavailable for: ${Array.from(new Set(missing)).join(', ')}. Reload before saving.`);
    return ids.map(id => byID.get(id));
}

/** Preserve identities for ordered insertions; explicit moves/deletes pass their keys directly. */
export function reconcileVisits(previous: RouteVisit[], ids: string[]): RouteVisit[] {
    const lengths = Array.from({length: previous.length + 1}, () => Array(ids.length + 1).fill(0));
    for (let i = previous.length - 1; i >= 0; i--) for (let j = ids.length - 1; j >= 0; j--)
        lengths[i][j] = previous[i].locationID === ids[j] ? 1 + lengths[i + 1][j + 1] : Math.max(lengths[i + 1][j], lengths[i][j + 1]);
    const result: RouteVisit[] = [];
    let i = 0, j = 0;
    while (j < ids.length) {
        if (i < previous.length && previous[i].locationID === ids[j]) { result.push(previous[i++]); j++; }
        else if (i < previous.length && lengths[i + 1][j] > lengths[i][j + 1]) i++;
        else result.push(createVisit(ids[j++]));
    }
    return result;
}
